import { connect } from 'react-redux'
import Screen from './DemonstrationManual'

export interface DemonstrationManualActions {
  //
}

export interface DemonstrationManualStoreStates {
  //
}

function mapDispatchToProps(): DemonstrationManualActions {
  return {
    //
  }
}

function mapStateToProps(): DemonstrationManualStoreStates {
  return {
    //
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Screen)
